import { Component, DestroyRef, inject, OnInit, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalComponent } from '../../../shared/components/modal/modal';
import { SelectComponent, SelectOption } from '../../../shared/components/select/select';
import { DataElementService } from '../../../core/services/data-element.service';
import { ToastService } from '../../../core/services/toast.service';
import { apiErrorMessage } from '../../../shared/utils/api-error';

@Component({
  selector: 'app-create-data-element-modal',
  imports: [ModalComponent, SelectComponent],
  templateUrl: './create-data-element-modal.html',
})
export class CreateDataElementModalComponent implements OnInit {
  closed = output<void>();
  saved = output<void>();

  private dataElementService = inject(DataElementService);
  private toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  protected name = signal('');
  protected definition = signal('');
  protected dataTypeId = signal('');
  protected dataTypeOptions = signal<SelectOption[]>([]);
  protected showErrors = signal(false);
  protected submitting = signal(false);
  protected loading = signal(true);

  ngOnInit(): void {
    this.dataElementService
      .getCdeDataTypes()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.dataTypeOptions.set(
            res.cdeDataTypes.map((t) => ({ value: t.id, label: t.dataType })),
          );
          this.loading.set(false);
        },
        error: () => this.loading.set(false),
      });
  }

  protected onSubmit(): void {
    this.showErrors.set(true);
    if (!this.name().trim() || !this.definition().trim() || !this.dataTypeId()) return;

    this.submitting.set(true);
    this.dataElementService
      .createDataElement({
        name: this.name().trim(),
        definition: this.definition().trim(),
        cdeDataTypeId: this.dataTypeId(),
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toastService.show('Data element created successfully');
          this.saved.emit();
        },
        error: (err) => {
          this.toastService.show(apiErrorMessage(err, 'Failed to create data element'), 'error');
          this.submitting.set(false);
        },
      });
  }
}
